const RefCodeGenerator = email => {
  return email + "_" + Math.floor(10000 + Math.random() * 10000000000)
}

export default RefCodeGenerator
